import { useContext } from 'react';

import { UserPreferencesContext } from 'contexts/UserPreferences';

const useUserPreferences = () => {
  return useContext(UserPreferencesContext);
};

export default useUserPreferences;
